const EVENTS = {
  STATE_UPDATED: 'STATE_UPDATED',
  STATE_RESET: 'STATE_RESET',
  UPDATE_STATE: 'UPDATE_STATE',
  TAG_REMOVED: 'TAG_REMOVED',
  TAG_JUMPED: 'TAG_JUMPED',
  HISTORY_LIMIT_CHANGED: 'HISTORY_LIMIT_CHANGED',
  HISTORY_CLEARED: 'HISTORY_CLEARED',
} as const;

// Type for event names with better type inference
type EventName = (typeof EVENTS)[keyof typeof EVENTS];

export { EVENTS, type EventName };
